import { Avatar } from '@creditornot/cb-avatar';
import { TextButtonLink } from '@creditornot/cb-button';
import { WindowNew } from '@creditornot/cb-icons';
import { RadioCard } from '@creditornot/cb-radio';
import React from 'react';

import { DeveloperPreview as DeveloperPreviewT } from 'apis/merchant-admin-server/types';

type Props = {
  checked: boolean;
  className?: string;
  onChange: (previewNumber: number) => void;
  preview: DeveloperPreviewT;
};

const DeveloperPreview = ({ checked, className, onChange, preview }: Props) => {
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = () => {
    onChange(preview.number);
  };

  const avatar = preview.user?.avatar_url ? (
    <Avatar size="small" imgSrc={preview.user.avatar_url} />
  ) : preview.user?.login ? (
    <Avatar size="small" initials={preview.user.login} />
  ) : (
    <Avatar size="small" />
  );

  return (
    <RadioCard
      onChange={handleChange}
      className={className}
      checked={checked}
      label={preview.title}
      subContent={
        <small>
          {preview.head?.ref}
          <br />
          {preview.head?.sha.slice(0, 7)}
          <br />
          <TextButtonLink
            size="inherit"
            iconPosition="right"
            icon={<WindowNew />}
            href={preview.html_url}
            rel="noopener noreferrer"
            target="_blank"
          >
            #{preview.number}
          </TextButtonLink>
        </small>
      }
      rightContent={avatar}
    />
  );
};

export default DeveloperPreview;
